export const FETCH_POSTS = 'FETCH_POSTS';
export const NEW_POSTS = 'NEW_POSTS';
export const FETCH_LOADTRUCKS = 'FETCH_LOADTRUCKS';
export const FETCH_LOC = 'FETCH_LOC';
export const FETCH_CONSIGNMENTS_CUSTOMER = 'FETCH_CONSIGNMENTS_CUSTOMER';
export const FETCH_CONSIGNMENTS_CUSTOMER_COUNTEDIT = 'FETCH_CONSIGNMENTS_CUSTOMER_COUNTEDIT';
export const FETCH_USER_CONSIGNMENTS_CUSTOMER = 'FETCH_USER_CONSIGNMENTS_CUSTOMER';
export const FETCH_CONSIGNMENTS_PRODUCT = 'FETCH_CONSIGNMENTS_PRODUCT';
export const FETCH_DELETE_ROW = 'FETCH_DELETE_ROW';
export const FETCH_EDIT_ROW = 'FETCH_EDIT_ROW';
export const FETCH_INSERT_ITEMS_ROW = 'FETCH_INSERT_ITEMS_ROW'; 
export const HAS_ERRORS = 'HAS_ERRORS';
export const RESET_ERROR_HANDLER = 'RESET_ERROR_HANDLER';
export const ADD_CONSIGNMENT_POPUP = 'ADD_CONSIGNMENT_POPUP';
export const FETCH_USER_CUSTOMER_PERMISSIONS = 'FETCH_USER_CUSTOMER_PERMISSIONS';
export const NOTICE_MESSAGE = 'NOTICE_MESSAGE';
export const FETCH_CONSIGNMENTS_CUSTOMER_INVENTORY = 'FETCH_CONSIGNMENTS_CUSTOMER_INVENTORY';
export const RESET_CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND = 'RESET_CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND';
export const CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND = 'CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND';
export const FETCH_USER_THIRD_PARTY_PERMISSIONS = 'FETCH_USER_THIRD_PARTY_PERMISSIONS';

export const FETCH_ALL_THIRD_PARTY_PERMISSIONS = 'FETCH_ALL_THIRD_PARTY_PERMISSIONS';
export const FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH = 'FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH';
export const CONSIGNMENTS_CUSTOMER_INVENTORY_REPLENISH_CHANGE = 'CONSIGNMENTS_CUSTOMER_INVENTORY_REPLENISH_CHANGE';
export const FETCH_CONSIGNMENTS_CUSTOMER_COUNT_NO_REPLENISH_CUST = 'FETCH_CONSIGNMENTS_CUSTOMER_COUNT_NO_REPLENISH_CUST';

export const FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH_DETAIL = 'FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH_DETAIL';

// export const ADD_CONSIGNMENT_POPUP_DEFAULT = 'ADD_CONSIGNMENT_POPUP_DEFAULT';


export const AuthActionType = {
    LOGOUT_SUCCESS: 'LOGOUT_SUGGESS',
    LOGOUT_FAIL: 'LOGOUT_FAIL',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAIL: 'LOGIN_FAIL',
    FETCH_LOGIN: 'FETCH_LOGIN',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAIL: 'REGISTER_FAIL',  
    AUTH_STATUS: 'AUTH_STATUS'
};

export const SidebarType = {
    HOME: '',
    REPORTS: 'REPORTS',
    NOTIFICATIONS: 'NOTIFICATIONS',
    SETTINGS: 'SETTINGS'
};

export const ShowSideMenuType = {    
    SHOWSIDEMENU: '',
    HIDESIDEMENU: 'HIDESIDEMENU'
}

export const HideDropdownMenuType = {
    SHOWDROPDOWNMENU: '',    
    HIDEDROPDOWNMENU: 'HIDEDROPDOWNMENU',
    BATTERY_PROGRAM: 'BATTERY_PROGRAM',
    OPERATIONS: 'OPERATIONS'
}

export const FETCH_TRANSFERS = 'FETCH_TRANSFERS';
export const FETCH_TRANSFERNO_DETAIL = 'FETCH_TRANSFERNO_DETAIL';
export const TRANSFERNO_STATE_RESET = 'TRANSFERNO_STATE_RESET'
export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERNO_DETAIL = 'FETCH_ORDERNO_DETAIL';
export const ORDER_TRANSFER_STATE_RESET = 'ORDER_TRANSFER_STATE_RESET';
export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_CUSTNO_DETAIL = 'FETCH_CUSTNO_DETAIL';
export const CUSTOMER_TRANSFER_STATE_RESET = 'CUSTOMER_TRANSFER_STATE_RESET';
export const FETCH_INVENTORY = 'FETCH_INVENTORY';
export const FETCH_INVENTORY_DETAIL = 'FETCH_INVENTORY_DETAIL';
export const FETCH_INVENTORY_RESET = 'FETCH_INVENTORY_RESET';
export const SUBMIT_TRANSFER_RESPONSE = 'SUBMIT_TRANSFER_RESPONSE';
export const SUBMIT_ORDER_RESPONSE = 'SUBMIT_ORDER_RESPONSE';
export const ADD_LINE_ORDERNO_DETAIL = 'ADD_LINE_ORDERNO_DETAIL';
export const DELETE_ROW_LINE_ORDERNO_DETAIL = 'DELETE_ROW_LINE_ORDERNO_DETAIL';
export const VALIDATE_PARTNO = 'VALIDATE_PARTNO';
export const SUBMIT_CUST_CORE_RESPONSE = 'SUBMIT_CUST_CORE_RESPONSE';
export const STATUS_UPDATE_STATE_RESET = 'STATUS_UPDATE_STATE_RESET';
export const STATUS_NOTICE_MESSAGE = 'STATUS_NOTICE_MESSAGE';
export const STATUS_ERR_MESSAGE = 'STATUS_ERR_MESSAGE';
export const PRINT_ORDER = 'PRINT_ORDER';
export const PRINT_TRANSFER = 'PRINT_TRANSFER';
export const FETCH_ORDERNOS_PRINT = 'FETCH_ORDERNOS_PRINT';


export const FETCH_INVOICES = 'FETCH_INVOICES';
export const FETCH_INVOICES_PRINT = 'FETCH_INVOICES_PRINT';
export const FETCH_RESET_INVOICES_PRINT = 'FETCH_RESET_INVOICES_PRINT';
export const FETCH_INVOICES_PRINT_RECORD_PRINTED = 'FETCH_INVOICES_PRINT_RECORD_PRINTED';
export const ROWS_DATA_SELECTED_INDEX_STATE = 'ROWS_DATA_SELECTED_INDEX_STATE';
export const PRINT_CONFIRMATION_RESPONSE = 'PRINT_CONFIRMATION_RESPONSE';
export const PRINT_CONFIRMATION_CLEAR_MESSAGES = 'PRINT_CONFIRMATION_CLEAR_MESSAGES';

export const ROTATE_REQUEST = 'ROTATE_REQUEST';
export const ROTATES = 'ROTATES';
export const CORE_PICKUP = 'CORE_PICKUP';
export const ROTATES_OUT_OF_STOCK = 'ROTATES_OUT_OF_STOCK';
export const NO_ROTATES_NEEDED_CB = 'NO_ROTATES_NEEDED_CB';
export const ROTATE_REQUEST_PARTNO_LIST = 'ROTATE_REQUEST_PARTNO_LIST';

export const RETURNS = 'RETURNS';
export const RETURNS_PARTNO_LIST = 'RETURNS_PARTNO_LIST';
export const NO_RETURNS_NEEDED_CB = 'NO_RETURNS_NEEDED_CB';

export const UPDATE_INVENTORY_DETAIL_BIN = 'UPDATE_INVENTORY_DETAIL_BIN';


export const ADMIN_FETCH_USERS = 'ADMIN_FETCH_USERS';
export const FETCH_CUSTOMER_PERMISSIONS = 'FETCH_CUSTOMER_PERMISSIONS';
export const SUBMIT_EDIT_USER_RESPONSE = 'SUBMIT_EDIT_USER_RESPONSE';

export const CHANGE_REPLENISHLABEL = 'CHANGE_REPLENISHLABEL';




